import GeneralConfig from './GeneralConfig.view';

export default GeneralConfig;
